// @ts-ignore
const SLUG_CHARS = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789']

const generateSlug = (length: number): string =>
  [...Array(length)].map((): string => SLUG_CHARS[Math.random() * SLUG_CHARS.length | 0]).join('')

export default generateSlug
